import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageSwitch } from '../components/LanguageSwitch';
import Logo from '../components/Logo';

// Small partner-site section to advertise your credit check service
// Replace LANDING_PAGE_URL with the real URL of your main landing page.

function PartnerCreditCheckSection() {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#FFFFFF' }}>
      <header className="sticky top-0 z-40 backdrop-blur-xl border-b border-slate-200" style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
        <div className="max-w-6xl mx-auto px-4 h-12 flex items-center justify-between gap-4">
          <Logo asLink to="/" />
          <div className="flex items-center gap-2">
            <LanguageSwitch />
            <Link to="/" className="text-xs md:text-sm text-slate-500 hover:text-slate-700">{t('common.backToHome')}</Link>
          </div>
        </div>
      </header>
    <section className="w-full max-w-5xl mx-auto flex-1 bg-white text-slate-900 border border-slate-200 rounded-3xl shadow-sm px-6 py-8 md:px-10 md:py-10 mt-6">
      <div className="grid gap-10 md:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] items-start">
        {/* Left column: copy & CTA */}
        <div className="space-y-7">
          <div className="space-y-3">
            <h2 className="text-3xl md:text-4xl font-semibold leading-tight tracking-tight">
              {t('partner.title')}
            </h2>
            <p className="text-base md:text-lg text-slate-700 max-w-xl">
              <span className="inline-flex items-center gap-2">
                <span className="text-lg">€</span>
                {t('partner.subtitle')}
              </span>
            </p>
          </div>

          <div className="space-y-4">
            <div className="space-y-3 text-sm md:text-base text-slate-800 leading-relaxed">
              <div className="flex items-start gap-3">
                <span className="mt-0.5">⚖️</span>
                <p>{t('partner.p1')}</p>
              </div>
              <div className="flex items-start gap-3 font-semibold">
                <span className="mt-0.5">⏰</span>
                <p>{t('partner.p2')}</p>
              </div>
            </div>
            <a
              href="./" // TODO: replace with your real landing page URL
              className="inline-flex items-center justify-center rounded-md bg-sky-600 px-6 py-3 text-sm md:text-base font-semibold text-white shadow-sm hover:bg-sky-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
            >
              {t('partner.cta')}
            </a>
          </div>
        </div>

        {/* Right column: proof points */}
        <div className="border border-slate-300 rounded-2xl bg-slate-50 px-4 py-5 md:px-6 md:py-6">
          <div className="space-y-5 text-sm md:text-base text-slate-800 leading-relaxed">
            <div className="flex items-start gap-3">
              <span className="mt-0.5">🛑</span>
              <p>{t('partner.stat1')}</p>
            </div>
            <div className="flex items-start gap-3">
              <span className="mt-0.5">💯</span>
              <p>{t('partner.stat2')}</p>
            </div>
            <div className="flex items-start gap-3">
              <span className="mt-0.5">🧮</span>
              <p>{t('partner.stat3')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  );
}

export default PartnerCreditCheckSection;
